<!-- 加盟商分账设置 -->
<template>
  <div class="cooperation_application">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="companyCode" suffix-icon="el-icon-search" placeholder="搜索加盟商编号" clearable @change="onSearch"></el-input>
      <el-input class="s_input" v-model="companyName" suffix-icon="el-icon-search" placeholder="搜索加盟商名称" clearable @change="onSearch"></el-input>
      <el-input class="s_input" v-model="contactMan" suffix-icon="el-icon-search" placeholder="搜索联系人" clearable @change="onSearch"></el-input>
    </div>
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="companyName" label="加盟商名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="companyCode" label="加盟商编号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="contactMan" label="联系人"></el-table-column>
        <el-table-column show-overflow-tooltip prop="contactTel" label="联系电话"></el-table-column>
        <el-table-column show-overflow-tooltip label="营业执照">
          <template slot-scope="scope">
            <span style="color: #0096ff; cursor: pointer" @click="previewImage(scope.row.busiLicenseUrl)">查看图片</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="creditCode" label="统一社会信用代码"></el-table-column>
        <el-table-column show-overflow-tooltip prop="createdTime" label="加盟时间"></el-table-column>
        <el-table-column show-overflow-tooltip prop="platformFeerate" label="平台分账">
          <template slot-scope="scope">{{ scope.row.platformFeerate || 0 }}%</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="distributeFeerate" label="加盟商分账">
          <template slot-scope="scope">{{ scope.row.distributeFeerate || 0 }}%</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)">修改</el-button>
            <!-- <el-button type="danger" plain @click="handleDel(scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    <el-dialog title="修改分账比例" :visible.sync="dialogVisible" :before-close="onCancel" width="55%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="ruleForm">
        <div style="display: flex; justify-content: space-evenly">
          <!-- <el-form-item label="平台比例" prop="input1">
            <el-input v-model="ruleForm.input1" placeholder="请输入" @change="validateInputs"></el-input>%
          </el-form-item>
          <el-form-item label="加盟商比例" prop="input2">
            <el-input v-model="ruleForm.input2" placeholder="请输入" @change="validateInputs"></el-input>%
          </el-form-item> -->
          <el-form-item label="平台比例" prop="input1">
            <el-input v-model="ruleForm.input1" placeholder="请输入" @input="handleInput1"></el-input>
            %
          </el-form-item>
          <el-form-item label="加盟商比例" prop="input2">
            <el-input v-model="ruleForm.input2" placeholder="请输入" @input="handleInput2"></el-input>
            %
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false
        }
      "
      :url-list="imgList"
    ></el-image-viewer>
  </div>
</template>

<script>
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      // 图片预览
      showViewer: false,
      imgList: [],
      add: 0,
      dialogVisible: false,
      tableData: [],
      companyName: "",
      companyCode: "",
      contactMan: "",
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      ruleForm: {
        input1: 0, //平台比例
        input2: 100, //加盟商比例
        companyCode: "",
      },
      rules: {
        input1: [
          // { required: true, message: '平台比例 不能为空', trigger: 'blur' },
          { pattern: /^\d+$/, message: "平台比例 只能输入整数", trigger: "blur" },
        ],
        input2: [
          // { required: true, message: '加盟商比例 不能为空', trigger: 'blur' },
          { pattern: /^\d+$/, message: "加盟商比例 只能输入整数", trigger: "blur" },
        ],
      },

      total: 0,
    }
  },

  created() {
    this.selectEnterpriseInfoList()
  },

  methods: {
    handleInput1(event) {
      const value = parseInt(event)
      if (isNaN(value)) {
        this.ruleForm.input1 = 0
      } else if (value < 0) {
        this.ruleForm.input1 = 0
      } else if (value > 100) {
        this.ruleForm.input1 = 100
      }
      this.ruleForm.input2 = 100 - this.ruleForm.input1
    },
    handleInput2(event) {
      const value = parseInt(event)
      if (isNaN(value)) {
        this.ruleForm.input2 = 0
      } else if (value < 0) {
        this.ruleForm.input2 = 0
      } else if (value > 100) {
        this.ruleForm.input2 = 100
      }
      this.ruleForm.input1 = 100 - this.ruleForm.input2
    },

    validateInputs() {
      // 确保输入的是数字
      if (/^\d+$/.test(this.ruleForm.input1) && /^\d+$/.test(this.ruleForm.input2)) {
        this.total = parseInt(this.ruleForm.input1) + parseInt(this.ruleForm.input2)
        if (this.total > 100) {
          // 这里可以添加超过 100%的提醒方式，例如弹出提示框或显示错误信息
          this.$message.warning("输入值之和不能超过 100%！")
        }
      } else {
        // 如果输入不是数字，也可以进行相应的提示
        this.$message.warning("请输入数字！")
      }
    },
    // 图片放大
    previewImage(url) {
      this.imgList[0] = url
      this.showViewer = true
    },
    // // 删除
    // handleDel(row) {
    //   this.$axios.post(this.$api.bannerDelete, {
    //     id: row.id,
    //     bizType: row.bizType,
    //   }).then((res) => {
    //     this.selectEnterpriseInfoList();
    //     this.$message({
    //       message: res.desc,
    //       type: "success",
    //     })
    //   }).catch(err => {
    //     this.$message({
    //       message: err.desc,
    //       type: 'error'
    //     })
    //   })
    // },
    // // 新增
    // handladd(index) {
    //   this.add = index;
    //   this.dialogVisible = true
    // },
    // 编辑
    handleEdit(row) {
      let data = Object.assign({}, row)
      this.ruleForm.companyCode = data.companyCode
      // 转换成数字类型
      this.ruleForm.input1 = parseInt(data.platformFeerate) //平台
      this.ruleForm.input2 = parseInt(data.distributeFeerate) //加盟商
      this.dialogVisible = true
    },
    // 发布
    submitForm(ruleForm) {
      console.log(this.ruleForm)

      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          this.$axios
            .post(this.$api.updateSettlement, {
              bizCode: this.ruleForm.companyCode,
              bizType: 1,
              platformFeerate: this.ruleForm.input1, //平台
              distributeFeerate: this.ruleForm.input2, //加盟商
            })
            .then(res => {
              this.selectEnterpriseInfoList()
              this.dialogVisible = false
              this.$message({
                message: res.desc,
                type: "success",
              })
            })
            .catch(err => {
              this.$message({
                message: err.desc,
                type: "error",
              })
            })
        } else {
          return false
        }
      })
    },
    onCancel() {
      this.dialogVisible = false
      // this.ruleForm = {}
    },

    onSearch() {
      this.clearData()
      this.selectEnterpriseInfoList()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },

    // 获取列表
    selectEnterpriseInfoList() {
      let params = {
        companyCode: this.companyCode,
        companyName: this.companyName,
        contactMan: this.contactMan,
        page: this.currentPage,
        pageSize: this.pageSize,
      }
      this.$axios
        .get(this.$api.settlementList, { params })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
        })
        .catch(err => {
          this.$message({
            message: err.desc,
            type: "error",
          })
        })
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.selectEnterpriseInfoList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectEnterpriseInfoList()
    },
  },
}
</script>

<style scoped lang="scss">
.cooperation_application {
  .el_upload__tip {
    text-align: center;
    margin-bottom: 20px;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 16px;
  }
  ::v-deep .el-dialog .el-dialog__header {
    padding: 11px 20px !important;
  }
  ::v-deep .el-input {
    width: 160px !important;
  }
  ::v-deep .el-dialog .el-input__inner {
    width: 160px !important;
  }
}
</style>
